import { Typography } from '@mui/material'
import React, { ReactElement } from 'react'

import { IconProps } from '@f-fertighaus/applications/Next/types/icon'
import {
  ElementWrapper,
  IconColumn,
  NameColumn,
  ValueColumn
} from '@f-fertighaus/applications/Next/views/houseDetailPage/HouseSections/sections/DetailsSection/common/DetailElement/DetailElement.styled'

export interface DetailElementProps {
  icon: React.ComponentType | ReactElement<IconProps>
  name: string
  verticalLayout?: boolean
  children?: React.ReactNode
}

export const DetailElement = (props: DetailElementProps) => {
  return (
    <ElementWrapper $verticalLayout={props.verticalLayout}>
      <IconColumn>
        {typeof props.icon === 'function' ? (
          React.createElement(props.icon)
        ) : (
          <props.icon.type {...props.icon.props} color='red' />
        )}
      </IconColumn>
      <NameColumn>
        <Typography variant='body2' fontWeight='fontWeightBold'>
          {props.name.replace(/\n/g, ' ')}
        </Typography>
      </NameColumn>
      <ValueColumn>{props.children}</ValueColumn>
    </ElementWrapper>
  )
}
